/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as PContact from "./../../common/models";
export interface ITExportContactsRequestArgs {
}
export class TExportContactsRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TExportContactsRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TExportContactsRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TExportContactsRequest();
    }
}
export interface ITExportContactsResponseArgs {
    csvUrl: string;
}
export class TExportContactsResponse {
    public csvUrl: string;
    constructor(args: ITExportContactsResponseArgs) {
        if (args != null && args.csvUrl != null) {
            this.csvUrl = args.csvUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[csvUrl] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TExportContactsResponse");
        if (this.csvUrl != null) {
            output.writeFieldBegin("csvUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.csvUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TExportContactsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.csvUrl = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.csvUrl !== undefined) {
            return new TExportContactsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TExportContactsResponse from input");
        }
    }
}
export interface ITImportContactsRequestArgs {
    csvFile?: Buffer;
    emailBlob?: string;
}
export class TImportContactsRequest {
    public csvFile?: Buffer;
    public emailBlob?: string;
    constructor(args?: ITImportContactsRequestArgs) {
        if (args != null && args.csvFile != null) {
            this.csvFile = args.csvFile;
        }
        if (args != null && args.emailBlob != null) {
            this.emailBlob = args.emailBlob;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TImportContactsRequest");
        if (this.csvFile != null) {
            output.writeFieldBegin("csvFile", thrift.Thrift.Type.STRING, 1);
            output.writeBinary(this.csvFile);
            output.writeFieldEnd();
        }
        if (this.emailBlob != null) {
            output.writeFieldBegin("emailBlob", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.emailBlob);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TImportContactsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_2: Buffer = input.readBinary();
                        _args.csvFile = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.emailBlob = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TImportContactsRequest(_args);
    }
}
export interface ITImportContactsResponseArgs {
}
export class TImportContactsResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TImportContactsResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TImportContactsResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TImportContactsResponse();
    }
}
